import styled from 'styled-components';
import { GRID_IMAGE_HEIGHT } from '~/src/root/components/ResultImageGrid/VirtualResultsGrid/const';

export const StyledResultsGridWrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: ${GRID_IMAGE_HEIGHT}px;
`;
